
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repayments-calculator/model",
      function () {
        return require("private-next-pages/repayments-calculator/model.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repayments-calculator/model"])
      });
    }
  